module.exports = __webpack_public_path__ + "img/UY.c2d8e322.svg";